module.exports = __webpack_public_path__ + "img/p4.ae6a58c0.png";